import styled from "@emotion/styled";
import * as React from "react";

import { Text } from "@livechat/design-system-react-components";

import { textEllipsisStyles } from "styles/common";

import { IFilterLabelValue } from "./interfaces";

export type FilterLabelValueType = string | IFilterLabelValue[];

interface IProps {
  value: FilterLabelValueType;
}

export const SelectedFilterLabel: React.FC<IProps> = ({ value }) => {
  if (!value) {
    return null;
  }

  if (Array.isArray(value)) {
    return (
      <Content>
        {value.map((v, i) =>
          i === 0 ? (
            <React.Fragment key={v.key}>{v.label}</React.Fragment>
          ) : (
            <React.Fragment key={v.key}>
              <b>&nbsp;or&nbsp;</b>
              {v.label}
            </React.Fragment>
          )
        )}
      </Content>
    );
  }
  return <span>{value}</span>;
};

const Content = styled(Text)`
  max-width: 220px;
  ${textEllipsisStyles}
`;
